export const SET_AUTH = "/auth/SET-AUTH",
  UNSET_AUTH = "/auth/UNSET-AUTH",
  SUCCESS_CAPTCHA = "/auth/SUCCESS_CAPTHCA";
